module.exports = __webpack_public_path__ + "assets/img/9910-ck.svg";